import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { Notification } from '../../../interfaces/notification';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/shared/services/data.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss', './notifications-modal.component.en.scss']
})
export class NotificationsModalComponent {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService
  ){
    this.notificationsSettings = data.notificationSettings;

    if(data.notifications) {
      this.notifications = data.notifications.notificationItems;
      this.totalNotificationsCount = data.notifications.totalCount;
      this.loadedNotificationsCount = data.notifications.notificationItems.length;
    }
  }

  @ViewChild('notificationContent') notificationContent!: ElementRef;
  catchContentTimerInterval: any;
  readNotificationsTimer: any;
  notificationsSettings: any;
  getNotificationsURL: string = environment.apiUrl + '/portal/notifications-api/getNotifications';
  readNotificationsURL: string = environment.apiUrl + '/portal/notifications-api/readNotifications';
  notifications: Notification[] = [];
  totalNotificationsCount: number = 0;
  loadedNotificationsCount: number = 0;
  isLoading: boolean = false;

  ngAfterViewInit() {
    this.catchContentRendered();
    window.addEventListener('scroll', this.onScroll, true);
  }

  ngOnInit() {
    this.readNewNotifications();
  }

  catchContentRendered() {
    this.catchContentTimerInterval = setInterval(() => {
      if (this.notificationContent) {
        this.catchScrollBarExists()
        clearInterval(this.catchContentTimerInterval);
      }
    }, 100);
  }

  catchScrollBarExists() {
    const scrollElement = document.querySelector('.mat-mdc-dialog-surface') as HTMLElement;
    const hasScroll = scrollElement.scrollHeight > scrollElement.clientHeight;
    if(!hasScroll && this.loadedNotificationsCount < this.totalNotificationsCount) this.getNotificationsData();
  }

  ngOnDestroy() {
    if(this.readNotificationsTimer){
      clearTimeout(this.readNotificationsTimer);
    }
    
    clearInterval(this.catchContentTimerInterval); 
    window.removeEventListener('scroll', this.onScroll, true);
  }

  getNotificationsData()
  {
    if(this.isLoading)
      return;

      
    const payload = {
      cultureCode : this.dataService.getCultureCode(),
      listSize: this.notificationsSettings.size,
      currentIndex: this.loadedNotificationsCount,
    }
    this.isLoading = true;
    this.dataService.getDataByToken(this.getNotificationsURL, payload).subscribe({
      next: (data) => {
        if(this.catchContentTimerInterval){
          this.readNotifications()
          this.catchContentTimerInterval = undefined;
        }
          
        if(data.notificationItems)
        {
          this.notifications.push(...data.notificationItems);
          this.loadedNotificationsCount += data.notificationItems.length;
          this.readNewNotifications();
        }
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e)
        this.isLoading = false
      },
    });
  }

  readNotifications = () => {
    const notificationsToRead = this.notifications.filter(x => !x.disabled && !x.readOnFront);
    if(!notificationsToRead.length)
      return;

    const readNotificationData = notificationsToRead.map(x => {
      return {
        date: x.date,
        id: x.id,
        type: x.type,
      }
    })

    const payload = {
      readNotificationData,
    }

    notificationsToRead.forEach(n => {
      n.readOnFront = true;
    })

    this.dataService.getDataByToken(this.readNotificationsURL, payload).subscribe({
      error: (e) => console.error(e),
    });
  }

  readNewNotifications = () => {
    this.readNotificationsTimer = setTimeout(() => {
      this.readNotifications();
      this.readNotificationsTimer == undefined;
    }, 2000)
  }

  onScroll = () => {
    if (this.loadedNotificationsCount < this.totalNotificationsCount) {
      const scrollElement = document.querySelector('.mat-mdc-dialog-surface') as HTMLElement;
      const offset = 10;
      if (scrollElement) {
        const scrollPosition = scrollElement.scrollHeight - scrollElement.clientHeight - offset;
        if (scrollElement.scrollTop >= scrollPosition) {
          this.getNotificationsData();
        }
      }
    }
  }
}
